module.exports = __webpack_public_path__ + "img/fake.6ba37597.png";